<owl-carousel-o [options]="customOptions">
    <ng-container *ngFor="let carouselText of ('page.login.carousel' | translate); let carouselIndex=index">
        <ng-template carouselSlide><img [src]="carouselImages[carouselIndex]" class="slideImage">
            <div class="textDesc">
                <h3>{{ carouselText['heading'] | translate }}</h3>
                <p>{{ carouselText['description'] | translate }}</p>
            </div>
        </ng-template>
    </ng-container>
</owl-carousel-o>